// eslint-disable-next-line @typescript-eslint/no-unused-vars
interface Date {
  getWeek(): number;
  getWeekYear(): number;
  getWeekWithYear(): string;
}

// eslint-disable-next-line no-extend-native
Object.defineProperty(Date.prototype, 'getWeek', {
  value() {
    const date = new Date(this.getTime());

    date.setHours(0, 0, 0, 0);
    date.setDate(date.getDate() + 3 - ((date.getDay() + 6) % 7));

    const week1 = new Date(date.getFullYear(), 0, 4);

    return (
      1 +
      Math.round(
        ((date.getTime() - week1.getTime()) / 86400000 -
          3 +
          ((week1.getDay() + 6) % 7)) /
          7
      )
    );
  },
});

// eslint-disable-next-line no-extend-native
Object.defineProperty(Date.prototype, 'getWeekYear', {
  value() {
    const date = new Date(this.getTime());

    date.setDate(date.getDate() + 3 - ((date.getDay() + 6) % 7));

    return date.getFullYear();
  },
});

// eslint-disable-next-line no-extend-native
Object.defineProperty(Date.prototype, 'getWeekWithYear', {
  value() {
    const pad = (num: number, digits = 2) =>
      num.toString().padStart(digits, '0');

    return `${this.getWeekYear()}-W${pad(this.getWeek())}`;
  },
});
